import React from "react";
import { HeaderBreadcrumbs } from "../../../shared";
import { Box, Typography, Alert, Stack } from "@mui/material";
import { useSupersetDashboard } from "../hooks/useSupersetDashboard";
import { Loader } from "../../../shared";

export const SupersetEmbedReport = ({ title, dashboardId, breadcrumbLinks }) => {
  const { state, dashboardRef } = useSupersetDashboard({ dashboardId });

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column", bgcolor: "#f5f5f5" }}>
      <Stack
        sx={{
          gap: "20px",
          position: "sticky",
          top: "0",
          bgcolor: "#fff",
          zIndex: 1101,
          p: "32px 32px 16px",
          pb: "16px",
          borderBottom: "1px solid #e6e6e6",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Stack gap="10px">
            <Typography variant="h5" sx={{ lineHeight: "30px" }}>
              {title}
            </Typography>
            <HeaderBreadcrumbs links={breadcrumbLinks} />
          </Stack>
        </Box>
      </Stack>

      <Box
        sx={{
          position: "relative",
          flex: 1,
          width: "100%",
          overflow: "hidden",
          bgcolor: "#fff",
        }}
      >
        <Box
          ref={dashboardRef}
          className="superset-dashboard-container"
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            visibility: state.isLoading || state.error ? "hidden" : "visible",
          }}
        />

        {state.isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "600px",
              bgcolor: "background.paper",
            }}
          >
            <Loader />
          </Box>
        )}

        {state.error && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              p: "24px",
              bgcolor: "background.paper",
            }}
          >
            <Alert severity="error">{state.error}</Alert>
          </Box>
        )}
      </Box>
    </Box>
  );
};
